import React, { useState } from 'react';
import axios from 'axios';
import './login.css';

const Login = ({ isOpen, onClose, onSwitchToRegister, onSwitchToForgotPassword }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('https://www.panafricanbookexchange-wandererspath.com/api/auth/login', { username, password });
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('role', response.data.role || "user");
            localStorage.setItem('username', username);
            setErrorMessage('');
            onClose();
            window.location.href = '/ebooks';
        } catch (error) {
            console.error('Login failed', error);
            const message = error.response?.data?.error || 'Login failed. Please try again.';
            setErrorMessage(message);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <span className="close" onClick={onClose}>&times;</span>
                <h2 className='login'>Login</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        className="input"
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                    <input
                        className="input"
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <button className="button" type="submit">Login</button>
                </form>

                {/* Switch to Forgot Password modal or route */}
                <p className="forgot-password-hint">
                    <span 
                        onClick={onSwitchToForgotPassword} 
                        style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
                    >
                        Forgot Password
                    </span>
                </p>

                {errorMessage && <p className="error-message">{errorMessage}</p>}
                
                <p>
                    Don't have an Account?{' '}
                    <span 
                        onClick={onSwitchToRegister} 
                        style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
                    >
                        Register
                    </span>
                </p>
            </div>
        </div>
    );
};

export default Login;